module.exports = __webpack_public_path__ + "img/home6.a3b006c1.svg";